/**
 * i18n provider + hooks.
 *
 * Pure utilities live in `./utils`; types in `./types`; this file
 * is only React components and hooks, so Fast Refresh works.
 */

import { useMemo, useState, type ReactNode } from 'react';
import { I18nContext, resolveMessage } from './utils';
import type { I18nContextValue, Locale } from './types';

export function I18nProvider({
  children,
  initialLocale = 'en',
}: {
  children: ReactNode;
  initialLocale?: Locale;
}) {
  const [locale, setLocale] = useState<Locale>(initialLocale);
  const value = useMemo<I18nContextValue>(
    () => ({
      locale,
      setLocale: (next) => setLocale(next),
      t: (key, params) => resolveMessage(locale, key, params),
    }),
    [locale],
  );
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}
